import { MapPin, Globe, Award, Clock } from 'lucide-react';

const stats = [
  { icon: MapPin, value: 'Dubai', label: 'Headquarters' },
  { icon: Globe, value: 'Global', label: 'Mindset' },
  { icon: Award, value: 'Platform', label: 'Operators' },
  { icon: Clock, value: 'Long-term', label: 'Partnerships' },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="font-manrope uppercase tracking-widest text-xs font-semibold text-primary">
              About Us
            </span>
            <h2
              className="font-oswald uppercase tracking-tight font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight mt-4"
              data-testid="about-headline"
            >
              <span className="text-gray-900">A different kind of</span>
              <br />
              <span className="text-primary">growth agency.</span>
            </h2>

            <div className="mt-6 md:mt-8 space-y-4">
              <p className="font-manrope text-base md:text-lg text-gray-500 leading-relaxed">
                Loose Leaf Media isn't just another marketing agency that added social media to their service list. We were born on the platforms.
              </p>
              <p className="font-manrope text-base md:text-lg text-gray-500 leading-relaxed">
                Our founders spent years inside platform ecosystems — working with creators, understanding the algorithms, and seeing firsthand what separates viral moments from sustainable growth.
              </p>
              <p className="font-manrope text-base md:text-lg text-gray-800 leading-relaxed">
                Based in Dubai with a global perspective, we bring that insider knowledge to brands and creators who are serious about building something that lasts.
              </p>
            </div>
          </div>

          {/* Right Content - Image & Stats */}
          <div className="space-y-8">
            {/* Image */}
            <div className="relative rounded-xl overflow-hidden shadow-lg">
              <img
                src="https://images.unsplash.com/photo-1671722294182-ed01cbe66bd1?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Team collaboration"
                className="w-full h-64 md:h-80 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-4">
              {stats.map((stat, index) => {
                const Icon = stat.icon;
                return (
                  <div
                    key={index}
                    className="bg-white border border-gray-200 rounded-xl p-6 text-center hover:shadow-lg transition-shadow"
                    data-testid={`about-stat-${index + 1}`}
                  >
                    <Icon className="w-6 h-6 text-primary mx-auto" />
                    <p className="font-oswald uppercase text-xl font-bold text-gray-900 mt-3">
                      {stat.value}
                    </p>
                    <p className="font-manrope text-xs text-gray-500 mt-1">
                      {stat.label}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
